import { checkListSummaryUser, searchJoken, searchLog } from 'types/SearchTypes'
import { fileInfo, jotai, keyInfo } from 'types/ReferTypes'
import { F_NUM, F_STR } from 'assets/FormatNumbers'

// 型定義と変換関数を両方ともここに保管する

// |postLoginInfo| =======================================================
export type reqLogin = {
  ID: string
  PASSWORD: string
}
export type resLogin = {
  loginKbn: 0 | 1 | 2
  MAIL: string
  NAME: string
  keyInfo: keyInfo[]
  isJapell: boolean
  isSuper: boolean
  token: string // アクセストークン
}

// |postChangePassword| =======================================================
export type reqChangePassword = {
  name: string
  pass: string
  rePass: string
  MAIL: string
}

// |postCreatePassword| =======================================================
export type reqCreatePassword = {
  mail: string
}

//========================================================
/**
 * 商品受領確認証画面
 * メイン参照テーブルはJJS360
 */
export type requestJuryo = {
  isJapell: boolean
  isCSV: boolean
  keyInfo: keyInfo[]
  searchJoken: searchJoken
  page: number
  perPage: number
}
export type responseJuryo = {
  JURYO_KBN: 0 | 1 | 2 // 受領区分(0: 未受領, 1: 受領, 2: 内容確認依頼)
  RENKEI_KBN: 0 | 1 // 連携区分(0: 未連携, 1: 連携済)
  DENPYO_NO: string // 伝票番号
  NOHIN_YMD: number // 納品日
  GYO_NO: number // 行
  JCU_KBN: number // 受注区分
  DENPYO_KBN: number // 伝票区分
  SHOHIN_CD: number // JPコード
  JAN_CD: string // JANコード
  // SHOHIN_KIKAKU: string // 品名／規格 → 品名と規格を分離 JBCC塩川@20250521
  SHOHIN: string // 品名
  KIKAKU: string // 規格
  SURYO: number // 数量
  NOHIN_SURYO: number // 納品数量
  GEN_TANKA: number // 原単価
  BAI_TANKA: number // 売単価
  TOKUI_CD: number // 得意先コード
  TOKUI_NM: string // 得意先名
  TEN_CD: number // 店舗コード
  TEN_NM: string // 店舗名
  JIGYO_CD: number // 事業所コード
  JIGYO_NM: string // 事業所名
  NAIYO: string // 内容確認依頼
}

/**
 * 検索項目からリクエストに必要な情報だけに絞り込む処理
 * @param searchJoken 商品受領確認証
 * @returns
 */
export const getRequestJoken = (isJapell: boolean, isCSV: boolean, keyInfo: keyInfo[], searchJoken: searchJoken, page: number, perPage: number): requestJuryo => {
  return {
    isJapell: isJapell,
    isCSV: isCSV,
    keyInfo: keyInfo,
    searchJoken: {
      ...searchJoken,
      DENPYO_NO: Number(searchJoken.DENPYO_NO) === F_NUM ? F_STR : searchJoken.DENPYO_NO,
    },
    page: page,
    perPage: perPage,
  }
}

//========================================================
/**
 * 商品受領確認証画面
 * メイン参照テーブルはJJS360
 */
export type requestJuryoUpdate = {
  MAIL: string // メールアドレス
  keyInfo: keyInfo[]
  selectList: {
    TOKUI_CD: number // 得意先コード
    TEN_CD: number // 店舗コード
    JCU_KBN: number // 受注区分
    DENPYO_NO: string // 伝票番号
    GYO_NO: number // 行
    NAIYO: string // 内容確認依頼
  }[]
}
export type responseJuryoUpdate = any[]
/**
 * 選択データからリクエストに必要な情報だけに絞り込む処理
 * @param searchJoken 商品受領確認証
 * @returns
 */
export const getRequestJuryoUpdate = (MAIL: string, keyInfo: keyInfo[], selectList: responseJuryo[]): requestJuryoUpdate => {
  return {
    MAIL: MAIL,
    keyInfo: keyInfo,
    selectList: selectList.map((r) => {
      return {
        TOKUI_CD: r.TOKUI_CD,
        TEN_CD: r.TEN_CD,
        JCU_KBN: r.JCU_KBN,
        DENPYO_NO: r.DENPYO_NO,
        GYO_NO: r.GYO_NO,
        NAIYO: r.NAIYO ? r.NAIYO : '',
      }
    }),
  }
}

export const getRequestJokenDetail = (selectList: string[], jotai: jotai) => {
  return {
    KANRI_NOS: selectList,
    jotai: jotai,
  }
}

//========================================================
/**
 * 商品受領確認証画面PDF出力
 * メイン参照テーブルはJJS360
 */
export type requestJuryoPDF = {
  selectList: {
    JIGYO_CD: number // 事業所コード
    TOKUI_CD: number // 得意先コード
    TEN_CD: number // 店舗コード
    JCU_KBN: number // 受注区分
    DENPYO_NO: string // 伝票番号
    GYO_NO: number // 行
    NAIYO: string // 内容確認依頼
  }[]
}
export type pdfData = {
  TOKUI_NM: string
  TEN_NM: string
  TOKUI_TEN_CD: string
  SHATEN_CD: string
  TORIHIKI_CD: string
  TORIHIKI_NM: string
  TEL: string
  FAX: string
  SEISAN_GK: number
  SEISAN_GK_TAX: number
  TAX: number

  NOHIN_YMD: number
  DENPYO_NO: string
  GYO_NO: number
  DENPYO_KBN: string // 0: 手入力受注、1: オンライン受注、2: JAPOSS　50: 直送売上
  JCU_KBN: string // 10: 売上、20: 返品、40: 添付、50: 値引
  JAN_CD: string
  SHOHIN_KIKAKU: string
  SURYO: number
  NOHIN_SURYO: number
  GEN_TANKA: number
  GENKA: number
  BAI_TANKA: number
  BAIKA: number
  KEPPIN: string
}
export type responseJuryoPDF = {
  result: pdfData[]
  pdfInfo: fileInfo
}
/**
 * 選択データからリクエストに必要な情報だけに絞り込む処理
 * @param searchJoken 商品受領確認証
 * @returns
 */
export const getRequestJokenPDF = (selectList: responseJuryo[]): requestJuryoPDF => {
  return {
    selectList: selectList.map((r) => {
      return {
        JIGYO_CD: r.JIGYO_CD,
        TOKUI_CD: r.TOKUI_CD,
        TEN_CD: r.TEN_CD,
        JCU_KBN: r.JCU_KBN,
        DENPYO_NO: r.DENPYO_NO,
        GYO_NO: r.GYO_NO,
        NAIYO: r.NAIYO ? r.NAIYO : '',
      }
    }),
  }
}

//========================================================
/**
 * ユーザー登録画面
 * メイン参照テーブルはJJSM001/JJSM002
 */
export type requestUser = {
  JIGYO_CD: number // 事業所コード
  TOKUI_CD: number // 得意先コード
  TEN_CD: number // 店舗コード
  MAIL: string // メールアドレス
}
export type responseUser = {
  JIGYO_CD: number // 事業所コード
  JIGYO_NM: string // 事業所名
  TOKUI_CD: number // 得意先コード
  TOKUI_NM: string // 得意先名
  TEN_CD: number // 店舗コード
  TEN_NM: string // 店舗名
  MAIL: string // メールアドレス
  NAME: string // 氏名
}
/**
 * リクエストに必要な情報だけに絞り込む処理
 * @param searchJoken 受領条件
 * @returns
 */
export const getRequestUser = (user: responseUser): requestUser => {
  return {
    JIGYO_CD: user.JIGYO_CD,
    TOKUI_CD: user.TOKUI_CD,
    TEN_CD: user.TEN_CD,
    MAIL: user.MAIL,
  }
}

// |postUserSendMail| =======================================================
export type requestUserMail = {
  MAIL: string // メールアドレス
  NAME: string // 氏名
}
/**
 * リクエストに必要な情報だけに絞り込む処理
 * @param selectList 選択ユーザー
 * @returns
 */
export const getRequestUserMail = (selectList: responseUser[]): requestUserMail[] => {
  const request = []
  for (let i = 0; i < selectList.length; i++) {
    request.push({
      MAIL: selectList[i].MAIL,
      NAME: selectList[i].NAME,
    })
  }
  return request
}

// |postUserDelete| =======================================================
export type requestUserDelete = {
  TOKUI_CD: number // 得意先コード
  TEN_CD: number // 店舗コード
  MAIL: string // メールアドレス
  ADD_MAIL: string // 削除者メールアドレス
}
/**
 * リクエストに必要な情報だけに絞り込む処理
 * @param selectList 選択ユーザー
 * @returns
 */
export const getRequestUserDelete = (selectList: responseUser[], ADD_MAIL: string): requestUserDelete[] => {
  const request = []
  for (let i = 0; i < selectList.length; i++) {
    request.push({
      TOKUI_CD: selectList[i].TOKUI_CD,
      TEN_CD: selectList[i].TEN_CD,
      MAIL: selectList[i].MAIL,
      ADD_MAIL: ADD_MAIL, // 同一の値が入るが、処理しやすくなるので配列に含める
    })
  }
  return request
}

// |postTokuiTenName| =======================================================
export type requestTokuiTen = {
  TOKUI_CD: number
  TEN_CD: number
}
export type responseTokuiTen = {
  TOKUI_NM: string
  TEN_NM: string
}

// |postUserAdd| =======================================================
export type requestUserAdd = {
  TOKUI_CD: number
  TEN_CD: number
  MAIL: string
}

/**
 * 受領条件照会画面
 * メイン参照テーブルはJTM360
 */
export type requestCSV = {
  isSummary: boolean // サマリ画面からのリクエストか判定
  formatNo: number // CSVのフォーマット番号
  JOKEN_KANRI_NO: string // 条件管理番号
  TOKUI_CD: number // 得意先コード
  checkList: responseJuryo[] // チェックがついたデータ
}
/**
 * 受領条件詳細のCSV出力のリクエストに必要な情報だけに絞り込む処理
 * @param searchJoken 受領条件
 * @returns
 */
export const getRequestCSV = (formatNo: number, JOKEN_KANRI_NO: string, TOKUI_CD: number, checkList: responseJuryo[]): requestCSV => {
  return {
    isSummary: false,
    formatNo: formatNo,
    JOKEN_KANRI_NO: JOKEN_KANRI_NO,
    TOKUI_CD: TOKUI_CD,
    checkList: checkList,
  }
}

/**
 * ユーザー登録画面
 * メイン参照テーブルはJJSM001/JJSM002
 */
export type requestUserUpdate = {
  JIGYO_CD: number // 事業所コード
  TOKUI_CD: number // 得意先コード
  TANTO_CD: number // 担当者コード
  checkListSummaryUser: checkListSummaryUser[]
  isNeededCheck: boolean // 代表以外のデータがあるかチェックの必要性
}
/**
 * ユーザー登録に必要なリクエストを取得する処理
 * @param searchJoken 率条件
 * @returns
 */
export const getRequestUserUpdate = (JIGYO_CD: number, TOKUI_CD: number, TANTO_CD: number, checkListSummaryUser: checkListSummaryUser[], isNeededCheck: boolean): requestUserUpdate => {
  return {
    JIGYO_CD: JIGYO_CD,
    TOKUI_CD: TOKUI_CD,
    TANTO_CD: TANTO_CD,
    checkListSummaryUser: checkListSummaryUser,
    isNeededCheck: isNeededCheck,
  }
}

/**
 * ログ照会画面
 * メイン参照テーブルはJJSD370
 */
export type requestLog = {
  isJapell: boolean // ジャペル判定
  keyInfo: keyInfo[] // 所属情報
  page: number // ページ数
  perPage: number // 表示件数/ページ
  searchJoken: {
    ADD_YMD_FROM: number // 年月日FROM
    ADD_YMD_TO: number // 年月日FROM
    JIGYO_CD: number // 事業所コード
    TOROKU_KBN: {
      torokuCheck: boolean // 登録チェックボックス
      sakujoCheck: boolean // 削除チェックボックス
      koshinCheck: boolean // 更新チェックボックス
    }
    ADD_MAIL: string // 登録者メールアドレス
    TOKUI_CD: number // 得意先コード
    TEN_CD: number // 店舗コード
    MAIL: string // メールアドレス
  }
}
export type logList = {
  ADD_YMD: number // 日付
  ADD_HNS: number // 時間
  TOROKU_KBN: 0 | 1 | 2 // 登録区分
  JIGYO_CD: number // 事業所コード
  JIGYO_NM: string // 事業所名
  TOKUI_CD: number // 得意先コード
  TOKUI_NM: string // 得意先名
  MAIL: string // メール
  NAME: string // 氏名
  ADD_MAIL: string // 登録者メール
  ADD_NAME: string // 登録者名
  TEN_CD: number // 店舗コード
  TEN_NM: string // 店舗名
}

export type responseLog = {
  table: logList[]
  allCount: number
}

/**
 * 検索項目からリクエストに必要な情報だけに絞り込む処理
 * @param searchLog ログ
 * @returns
 */
export const getRequestLog = (isJapell: boolean, keyInfo: keyInfo[], page: number, perPage: number, searchLog: searchLog): requestLog => {
  return {
    isJapell: isJapell,
    keyInfo: keyInfo,
    page: page,
    perPage: perPage,
    searchJoken: {
      ADD_YMD_FROM: searchLog.ADD_YMD_FROM,
      ADD_YMD_TO: searchLog.ADD_YMD_TO,
      JIGYO_CD: searchLog.JIGYO_CD,
      TOROKU_KBN: {
        torokuCheck: searchLog.TOROKU_KBN.torokuCheck,
        sakujoCheck: searchLog.TOROKU_KBN.sakujoCheck,
        koshinCheck: searchLog.TOROKU_KBN.koshinCheck,
      },
      ADD_MAIL: searchLog.ADD_MAIL,
      TOKUI_CD: searchLog.TOKUI_CD,
      TEN_CD: searchLog.TEN_CD,
      MAIL: searchLog.MAIL,
    },
  }
}

/**
 * 手入力分照会画面
 * メイン参照テーブルはJTD340
 */
export type requestTenyuryoku = {
  SYORI_YMD_FROM: number // 処理票日付FROM
  SYORI_YMD_TO: number // 処理票日付TO
  ADD_YMD_FROM: number // 登録日FROM
  ADD_YMD_TO: number // 登録日TO
  NYUKIN_YMD_FROM: number // 相殺/入金日FROM
  NYUKIN_YMD_TO: number // 相殺/入金日TO
  SIIRE_CD: number // 仕入先コード
  JIGYO_CD: number // 事業所コード
  TANTO_CD: number // 担当者コード
  NAIYO_KBN1: number // 精算内容区分1
  NAIYO_KBN2: number // 精算内容区分2
  SEISAN_KOUMOKU: number // 精算項目
  DENPYO_NO: string //	処理No
  SEISAN_NAIYO: string // 精算内容
  JOTAI: jotai // 状態(未承認, 承認, 否認)
}
